import * as React from 'react';
import { Banner, Breadcrumbs, Button, Text } from '@hotjar/hotsauce';
import { useTranslationWithPrefix, useHelpHotjarUrl } from '@hotjar/translations';
import { PageHeader } from '@hotjar/webapp/features/Core/PageHeader';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { SITE } from '@hotjar/webapp/constants/routes';
import { AddOrganizationForm } from './AddOrganizationForm';

const TRANSLATION_DOMAIN = 'account:new-organization';

interface Props {
  addOrganization(organizationName: string): void;
  isAccountAdmin: boolean;
  isLoading: boolean;
}

export function AddOrganization({
  addOrganization,
  isAccountAdmin,
  isLoading,
}: Props): React.ReactElement {
  const { t } = useTranslationWithPrefix(TRANSLATION_DOMAIN);
  const helpHotjarUrl = useHelpHotjarUrl();

  if (!isAccountAdmin) {
    return (
      <Banner
        kind="warning"
        actionText={t('account-admin-support-link')}
        actionHref={`${helpHotjarUrl}/requests/new?ticket_form_id=360000390353`}
      >
        {t('only-account-admin')}
      </Banner>
    );
  }

  return (
    <div>
      <PageHeader
        title={t('title')}
        breadcrumbItems={
          <Breadcrumbs.Item href={getRoute(SITE.LIST.path)}>{t('back-link')}</Breadcrumbs.Item>
        }
      />
      <Text as="p">{t('info-text')}</Text>
      <AddOrganizationForm addOrganization={addOrganization} />
      <Button form="create-org-form" type="submit" isLoading={isLoading}>
        {t('add-organization')}
      </Button>
    </div>
  );
}
